import React from "react";
import BaseInnerBlankCardMainText from "../../sisu/table/BaseInnerBlankCardMainText.sisu";

const NeoInnerBlankCardMainText = (props) => {
  return (<BaseInnerBlankCardMainText custom="texto-card-principal" {...props}>
      {props.children}
    </BaseInnerBlankCardMainText>);
};

export default NeoInnerBlankCardMainText;